import { toastError } from 'components/ToastComponent/ToastComponent'
import * as providers from './provider'

export default setRoot => {
  // example action to change state
  const action = num => setRoot(prev => ({ ...prev, num: prev.num + num }))

  // example action to post API
  const samplePost = async () => {
    const [err, res] = await providers.genericPost({})

    if (err) {
      toastError('Erro')
    }
    return res.data
  }

  // example action to fetch from API
  const sampleFetch = async () => {
    const [err, res] = await providers.getSample()

    if (err) {
      toastError('Erro ao buscar propriedade.')
      return
    }

    const sample = res.data
    setRoot(prev => ({ ...prev, sample }))
  }

  return { action, samplePost, sampleFetch }
}
